module.exports = __webpack_public_path__ + "img/img-94e737.png";